import React, { useEffect } from "react";

import { NavLink, useHistory } from "react-router-dom";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";

import { getGroup } from "utils/auth";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import { Svg } from "./Svg.js";

import { isEmpty } from "utils/array";

import Can from "components/Can";

import { PERMISSION, MODULE_LIST } from "../modules";
import { useSelector } from "react-redux";
import {isSuper,isAdmin} from 'utils/auth'

import removeParentByPermissions from 'utils/permissions'

const BootstrapTooltip = withStyles((theme) => ({
    arrow: {
        color: theme.palette.common.black,
    },
    tooltip: {
        backgroundColor: theme.palette.common.black,
    },
}))(({ classes, ...props }) => <Tooltip arrow classes={classes} {...props} />);

const useStyles = makeStyles({
    navItemFixer: {
        "&:before": {
            display: "none !important",
        },
    },
});

export function ScanModules({ id }) {
    const modules = [
        "dashboard",
        "analitico",
        "operacional",
        "minha_empresa",
        "cadastro_user",
        "cadastro_relacao",
        "criar_empresa",
        "cadastro_usuario",
        "romaneio",
        "protocolo",
        "auditoria",
        "ocorrencia",
        "prazo_entrega",
        "romaneio_automatico",
        "rota",
        "verificadas",
        "operacoes",
        "rastreamento",
        "pendencias",
        "frete",
        "end_sem_rota",
        "documentos",
        "sefaz",
        "cte",
        "azp",
        "cte_criar",
        "cte_listar",
        // "devolucao",
        "comprovacoes",
    ];

    const authState = useSelector((state) => state.auth);

    const found = modules.find((element) => element === id);

    if (!getGroup(authState).getUser().isGroupAtivos()) {
        return false;
    }

    if (found === undefined) {
        return false;
    }

    return true;
}

function Module({
    id,
    permission = true,
    parent,
    show,
    route,
    icon = faTimes,
    title,
    patch = null,
    ...props
}) {
    const classes = useStyles({ title });

    const parentRoute = parent ? parent.route : "";

    route = parentRoute + route;
    
    const Component = () => (
        <BootstrapTooltip
            title={title}
            placement="right"
            disableHoverListener={!!parent || !title}
        >
            <li
                className={`menu no-arrow ${
                    ScanModules({ id: id }) ? "disabled" : "default"
                }`}
            >
                <NavLink
                    to={"/app" + route}
                    className={!title && classes.navItemFixer}
                >
                    <i className="zmdi zmdi-hc-fw">
                        {patch ? Svg(patch) : <FontAwesomeIcon icon={icon} />}
                    </i>
                    {title && (
                        <span
                            className="nav-text animated fadeIn"
                            style={{ textTransform: "none" }}
                        >
                            {title}
                        </span>
                    )}
                </NavLink>
            </li>
        </BootstrapTooltip>
    );
    return permission ? (
        <Can do={PERMISSION} on={{ __type: id }} {...props}>
            <Component />
        </Can>
    ) : (
        <Component {...props} />
    );
}

export default function Content({ showTitle, onCollapse }) {
    const classes = useStyles();
    const history = useHistory();
    const authState = useSelector((state) => state.auth);
    const SUPER = isSuper(authState);
    const ADMIN = isAdmin(authState);

    function filterSuper(module){
        return module.super?SUPER:module.admin?(ADMIN|| SUPER):(module.enabled && module.menu)
    }

    useEffect(() => {
        const closest = (el, selector) => {
            try {
                let matchesFn;

                [
                    "matches",
                    "webkitMatchesSelector",
                    "mozMatchesSelector",
                    "msMatchesSelector",
                    "oMatchesSelector",
                ].some(function (fn) {
                    if (typeof document.body[fn] === "function") {
                        matchesFn = fn;
                        return true;
                    }

                    return false;
                });

                let parent;

                while (el) {
                    parent = el.parentElement;

                    if (parent && parent[matchesFn](selector)) {
                        return parent;
                    }

                    el = parent;
                }
            } catch (error) {}

            return null;
        };

        const pathname = `#${history.location.pathname}`; // get current path

        const subMenuLi = document.querySelectorAll(".sub-menu > li");

        for (let i = 0; i < subMenuLi.length; i++) {
            subMenuLi[i].onclick = function (event) {
                event.stopPropagation();
            };
        }

        const menuLi = document.getElementsByClassName("menu");

        const collpses = [
            'ferramentas',
            'cadastro',
            'documentos',
            'integracoes',
            'cte',
        ]
        
        for (let i = 0; i < menuLi.length; i++) {
            menuLi[i].onclick = function (event) {
                for (let j = 0; j < menuLi.length; j++) {
                    const parentLi = closest(this, "li");

                    if (
                        menuLi[j] !== this &&
                        (parentLi === null ||
                            !parentLi.classList.contains("open"))
                    ) {
                        menuLi[j].classList.remove("open");
                    }
                }

                if (collpses.includes(menuLi[i].id)) {
                    handleCollapse(false);
                }

                this.classList.toggle("open");
                event.stopPropagation();
            };
        }

        const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element

        try {
            const activeNav = this.closest(activeLi, "ul"); // select closest ul

            if (!activeNav) return;

            if (activeNav.classList.contains("sub-menu")) {
                this.closest(activeNav, "li").classList.add("open");
            } else {
                this.closest(activeLi, "li").classList.add("open");
            }
        } catch (error) {}
    }, []);

    function handleCollapse(state) {
        onCollapse && onCollapse(state);
    }

    return (
        <ul className="nav-menu d-flex flex-column justify-content-between">
            {/* {MODULE_LIST.filter((module) => module.enabled && module.menu).map(
                (module, index) => {
                    const hasChildren =
                        module.children && !isEmpty(module.children);
                    const habilited = removeParentByPermissions(authState,module.children,SUPER,ADMIN,module.id)
                    return hasChildren ? (
                        habilited?
                        <BootstrapTooltip
                            key={module.id}
                            title={module.title}
                            placement="right"
                        >
                            <li id={module.id} className="menu collapse-box">
                                <Button
                                    href="javascript:void(0)"
                                    className={
                                        !showTitle && classes.navItemFixer
                                    }
                                >
                                    <i className="zmdi zmdi-hc-fw">
                                        <FontAwesomeIcon icon={module.icon} />
                                    </i>
                                    {showTitle && (
                                        <span className="nav-text animated fadeIn delay-1s">
                                            {module.title}
                                        </span>
                                    )}
                                </Button>

                                <ul className="sub-menu">
                                    {module.children.filter((module) => filterSuper(module)).map((child, index) => (
                                        <Module
                                            key={index}
                                            parent={module}
                                            show={showTitle}
                                            {...child}
                                            title={showTitle && child.title}
                                        />
                                    ))}
                                </ul>
                            </li>
                        </BootstrapTooltip>:''
                    ) : (
                        <Module key={index} {...module} title={module.title} />
                        
                    )
                }
            )} */}
        </ul>
    );
}
